"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubProcessViewModel = void 0;
const ActivityViewModel_1 = require("./ActivityViewModel");
class SubProcessViewModel extends ActivityViewModel_1.ActivityViewModel {
}
exports.SubProcessViewModel = SubProcessViewModel;
//# sourceMappingURL=SubProcessViewModel.js.map